import React, { Component } from "react";
import { withDomains, RESTExecutor } from "../../lib/domain";
import {
  Result,
  Button,
  Popconfirm,
  Tag,
  Table,
  Row,
  message,
  Spin,
} from "antd";
import {
  typeRepresentation,
  overrideHeaderTitle,
  overrideHeaderBack,
  schema_to_field,
  showErrorInNotification,
  NetworkDelaySearch,
  formatMoney,
} from "../../lib/util";
import Title from "antd/lib/typography/Title";

import { PopUpForm } from "../../lib/ui/popupform";
import { Link } from "react-router-dom";
import Search from "antd/lib/input/Search";
import { COLORS } from "../theme";
import { BasicHeader } from "../../components/basic_header";
import { CustomSwitch, TransparentButton } from "../../components/basic_items";
import ErrorWrapper from "../../lib/error_wrapper";
import { generateURL } from "../../util/ui_util";
import { FilterList, HighlightOff } from "@material-ui/icons";
const queryString = require("query-string");

class TableDataList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      table_meta: {},
      table_data_list: [],

      //  For dynamic columns
      table_cols_list: [],

      //  For allowed methods per table
      allowed_methods: [],

      // For table name
      current_table_name: "",

      //  For dynamic form
      data_field: [],
      // For table patch/add data form values
      data_value: {},
      form_visibility: false,
      edit_id: null,
      filter_schema: [],
      table_switch:'data',

      filter_query: {
        per_page: 100,
        page: 1,
      },
    };
    this.table_id = props.match.params.table_id;
    this.delay_search = new NetworkDelaySearch();
    console.log(this.state,'this is all the state');

    this.get_detail =  RESTExecutor.detail()
      .config({
        label: "table_detail",
      })
      .callbacks(
        (success) => {
          this.setState(
            {
              loading: false,
              ...this.handleTableSchemaChange(success.result),
              allowed_methods: success.result.allowed_methods || [],
              current_table_name: success.result.name,
              filter_schema: schema_to_field(success.result.filter_config),
            },
            () => {
              this.list_table_data
                .forId(this.table_id)
                .config({
                  params: {
                    ...this.state.filter_query,
                  },
                })
                .execute();
            }
          );
        },
        (error) => {
          this.setState({ loading: false });
          showErrorInNotification(error);
        }
      )
      .forId(this.table_id)
      .connect(props.domains.usertable);
    this.get_detail_file =  RESTExecutor.detail()
      .config({
        label: "file_detail",
        params:{
          ...this.state.filter_query,
        }
      })
      .callbacks(
        (success) => {
          console.log({success});
          this.setState(
            {
              loading: false,
              ...this.handleTableSchemaChange(success.result),
              table_data_list:success.result.rows,
              allowed_methods: success.result.allowed_methods || [],
              current_table_name: success.result.name,
              filter_schema: schema_to_field(success.result.filter_config),
            }
          );
        },
        (error) => {
          this.setState({ loading: false });
          showErrorInNotification(error);
        }
      )
      .forId(this.table_id)
      .connect(props.domains.usertable);

    this.list_table_data = RESTExecutor.list()
      .config({
        label: "table_data",
        params: {
          per_page: 100,
          page: 1,
        },
      })
      .forId(this.table_id)
      .callbacks(
        (success) => {
          this.setState({
            // loading: false,
            // allowed_methods: success.result.allowed_methods,
            // ...this.handleTableSchemaChange(success.result),
            // current_table_name: success.result.title,
            table_data_list: success.result.rows,
            table_meta: success.meta || {},
          });
          // overrideHeaderTitle(`${success.result.title} | Data`);
        },
        (error) => {
          showErrorInNotification(error);
          // if (error.error_message) {
          //   if (error.error_message.not_found) {
          //     this.setState({
          //     })
          //   }
          // }
        }
      )
      .connect(props.domains.usertable);

    this.post_table_data = RESTExecutor.post()
      .config({
        label: "table_data",
      })
      .callbacks((success) => {
        this.setState({
          form_visibility_file_upload: false,
          form_visibility: false,
          edit_id: null,
          data_value: {},
        });
      })
      .connect(props.domains.usertable);

    this.patch_table_data = RESTExecutor.patch()
      .config({
        label: "table_data_detail",
        params: {
          table_id: null,
          data_id: null,
        },
      })
      .connect(props.domains.usertable);

    this.patch_table_file_data = RESTExecutor.post()
      .config({
        label: "table_file_data_detail",
        headers: { Accepts: "multipart/form-data" },

        params: {
          table_id: null,
          // data_id: null,
        },
      })
      .callbacks(()=>{
        this.setState({
          form_visibility_file_upload: false,
        });
      },()=>{
       
      })
      .connect(props.domains.usertable);

    this.delete_table_data = RESTExecutor.delete().connect(
      props.domains.usertable
    );
    this.delete_table_file = RESTExecutor.delete().connect(
      props.domains.usertable
    );
  }

  getRenderer = (value, type, preview_params) => {
    if (typeof preview_params === "object") {
      if (preview_params.type == "VIEW") {
        return (
          <Link
            to={generateURL({
              id: preview_params.id,
              params: {
                id: value,
              },
            })}
          >
            <span
              className="sub-heading-3 hand-cursor"
              style={{
                color: COLORS.secondary,
              }}
            >
              {value}
            </span>
            {/* <Tag className='hand-cursor' color={COLORS.primary}>
                                        {item.label}
                                    </Tag> */}
          </Link>
        );
      }
    }

    switch (type) {
      case "list":
        return (
          <div>
            <ul>
              {value.map((item) => {
                if (typeof item === "string") {
                  return <li>{item}</li>;
                } else {
                  return <li>{JSON.stringify(item, null, 3)}</li>;
                }
              })}
            </ul>
          </div>
        );
      case "boolean":
        if (value) {
          return <Tag color={COLORS.primary}>{JSON.stringify(value)}</Tag>;
        } else {
          return (
            <Tag color={COLORS.danger_primary}>{JSON.stringify(value)}</Tag>
          );
        }

      default:
        return value;
    }
  };

  handleTableSchemaChange = (tabledata = {}) => {
    console.log({tabledata});
    let schema = tabledata.schema;
    console.log({ schema });
    let fields = schema_to_field(schema);
    let cols = [];
    schema.map((item, index) => {
      let d = item;
      let list_prop = {};
      if (d.validation.type === "list") {
        list_prop = {
          multiple: true,
          count: 1,
        };
      }
      // fields.push({
      //   index: key,
      //   name: d.display_name,
      //   type: typeRepresentation(d.validation.type),
      //   ...list_prop
      // });
      cols.push({
        title: d.display_name,
        dataIndex: item.name,
        render: (value, record) => {
          return this.getRenderer(
            value,
            d.validation.type,
            d.validation.preview_params
          );
        },
      });
    });
    if (
      tabledata.allowed_methods &&
      (tabledata.allowed_methods.includes("EDIT") ||
        tabledata.allowed_methods.includes("DELETE"))
    ) {
      cols.push({
        title: "",
        dataIndex: "id",
        width: 150,
        render: (id, data) => {
          return (
            <span>
              {tabledata.allowed_methods.includes("EDIT") && (
                <Button
                  type="link"
                  onClick={() => {
                    this.setState({
                      data_value: JSON.parse(
                        JSON.stringify(data.__original_data__ || data)
                      ),
                      edit_id: id,
                      form_visibility: true,
                    });
                  }}
                >
                  Edit
                </Button>
              )}
              {tabledata.allowed_methods.includes("DELETE") && (
                <Popconfirm
                  title="Are you sure you want  to delete this data?"
                  onConfirm={() => {
                   this.state.table_switch === 'data'? this.delete_table_data
                      .config({
                        label: "table_data_detail",
                        params: {
                          table_id: this.table_id,
                          data_id: id,
                        },
                      }):
                      this.delete_table_file.config({
                        
                        url:`dynamic/${this.table_id}/file/${id}`
                      })
                      .callbacks(
                        (success) => {
                          this.get_detail_file.execute();
                        },
                        (error) => {
                          message.error("Cannot delete selected item.");
                        }
                      )
                      .execute();
                  }}
                >
                  <Button type="link" style={{ color: "red" }}>
                    Delete
                  </Button>
                </Popconfirm>
              )}
              {/* {tabledata.allowed_methods.includes('DETAIL') &&
              <Link to={`/recon/table/${this.table_id}/${id}`}>
                <Button type='link'>
                  View
                </Button>
              </Link>
            } */}
            </span>
          );
        },
      });
    }

    return { data_field: fields, table_cols_list: cols };
  };

  handlePostPatch = (data) => {
    console.log("data is", data);
    // let _selected_table=this.state.selected_table;
    if (this.state.edit_id) {
      //  handle patch
      this.patch_table_data
        .config({
          label: "table_data_detail",
          params: {
            table_id: this.table_id,
            data_id: this.state.edit_id,
          },
        })
        .callbacks((success) => {
          this.list_table_data.execute();
          this.setState({ form_visibility: false });
        })
        .execute(data);
    } else {
      this.post_table_data
        .forId(this.table_id)
        .callbacks(
          (success) => {
            this.list_table_data.execute();
            this.setState({ form_visibility: false });
          },
          (error) => {}
        )
        .execute(data);
    }
  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };
  render() {
    const {
      loading,
      allowed_methods,
      table_data_list,
      table_cols_list,
      data_field,
      current_table_name,
      form_visibility,
      form_visibility_file_upload,
      filter_query,
      table_meta,
      filter_schema,
      table_switch,
    } = this.state;
    if (loading) {
      return (
        <center>
          <Spin />
        </center>
      );
    }

    let list_table_data_resp = this.list_table_data.response();
    let get_detail_resp = this.get_detail.response();

    let post_response =
      (this.post_table_data && this.post_table_data.response()) || {};
    let patch_response =
      (this.patch_table_data && this.patch_table_data.response()) || {};

    let patch_table_file_data_resp=this.patch_table_file_data.response();

    return (
      <ErrorWrapper
        error={get_detail_resp}
        onReload={() => {
          this.get_detail.forId(this.table_id).execute();
        }}
      >
        <BasicHeader
          subtitle="Data"
          titleType="Table"
          title={current_table_name}
          right={[
            <CustomSwitch 
            value={table_switch}
            falseItem={'data'}
            trueItem={'file'}
            onChange={(value) => {
          this.setState({table_switch:table_switch === 'data'?'file':'data',
        },
        (this.state.table_switch === 'data'?this.get_detail_file.execute():this.get_detail.execute())

          )
          }}
            />,

            <TransparentButton
              label="Add File"
              className="cta-primary"
              hint="Add New Data"
              onClick={() => {
                this.setState({
                  form_visibility_file_upload: true,
                  data_value: {},
                  edit_id: null,
                });
              }}
            />,
            allowed_methods.includes("ADD") ? (
              <TransparentButton
                label="Add New"
                className="cta-primary"
                hint="Add New Data"
                onClick={() => {
                  this.setState({
                    form_visibility: true,
                    data_value: {},
                    edit_id: null,
                  });
                }}
              />
            ) : null,
          ]}
        />

        <PopUpForm
          title={"Filter Data"}
          show_title_only
          forCreate={true}
          okText="Filter"
          initialData={this.state.filter_query}
          fields={filter_schema}
          open={this.state.filter_form_visibility}
          networkState={{}}
          onClose={() => this.setState({ filter_form_visibility: false })}
          onSubmit={(data) => {
            this.stateUpdater({
              stateKey: "filter_query",
              appendObj: data,
              callback: () => {
                this.setState({ filter_form_visibility: false });
                this.props.history.push({
                  search: queryString.stringify({
                    ...this.state.filter_query,
                    page: 1,
                  }),
                });
              },
            });
            // this.handlePostPatch(data);
          }}
        />
        <div className="filter-card">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "nowrap",
              paddingTop: 4,
              paddingBottom: 12,
            }}
          >
            <Search
              autoFocus
              allowClear
              placeholder="Search For"
              style={{}}
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: "filter_query",
                  valueKey: "query",
                  value: e.target.value,
                  callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          per_page: 100,
                          page: 1,
                        }),
                      });
                    });
                  },
                });
              }}
            />
            {filter_schema.length > 0 ? (
              <Button
                shape="circle"
                onClick={() => {
                  this.setState({ filter_form_visibility: true });
                }}
                type="primary"
                style={{ marginLeft: 16 }}
                title="Filter"
                icon={
                  <FilterList
                    style={{
                      width: 20,
                    }}
                  />
                }
              ></Button>
            ) : null}

            {filter_schema.length > 0 ? (
              <Button
                shape="circle"
                disabled={Object.keys(filter_query).length < 3}
                onClick={() => {
                  this.props.history.push({});
                }}
                type="danger"
                style={{ marginLeft: 16 }}
                title="Clear"
                icon={
                  <HighlightOff
                    style={{
                      width: 20,
                    }}
                  />
                }
              ></Button>
            ) : null}
          </div>
        </div>

        <ErrorWrapper
          error={list_table_data_resp}
          onReload={() => {
            this.list_table_data.execute();
          }}
        >
          <div
            className="default-card"
            style={{
              padding: 0,
            }}
          >
            <PopUpForm
              title={`Data for ${current_table_name}`}
              forCreate={this.state.edit_id ? false : true}
              initialData={this.state.data_value}
              fields={data_field}
              width="80%"
              open={form_visibility}
              networkState={this.state.edit_id ? patch_response : post_response}
              onClose={() =>
                this.setState({
                  form_visibility: false,
                })
              }
              onSubmit={(data) => {
                console.log("DATA", data);
                this.handlePostPatch(data);
              }}
            />
            <PopUpForm
              title={`File For ${current_table_name}`}
              forCreate={this.state.edit_id ? false : true}
              initialData={this.state.data_value}
              fields={[
                {
                  name: "File Upload",
                  index: "file",
                  type: "file",
                },
              ]}
              width="80%"
              open={form_visibility_file_upload}
              networkState={patch_table_file_data_resp}
              onClose={() =>
                this.setState({
                  form_visibility_file_upload: false,
                })
              }
              
              onSubmit={(data) => {
                console.log({ data });
                // data.configs = JSON.stringify(data.configs);
                if (!data.file) {
                  message.warn("Cannot upload empty data...");
                  return;
                } else {
                  let _formdata = new FormData();
                  Object.keys(data).map((key) => {
                    console.log(data[key], "asdklfjlkjl");
                    _formdata.append(key, data[key]);
                  });
                  // message.warn("END POINT NOT MADE")

                  this.patch_table_file_data
                    .forId(this.table_id)
                    .execute(_formdata);
                }
               
                // this.handlePostPatch(data);

                // this.handlePostPatch(data);
              }}
            />
            <Table
              pagination={{
                simple: false,
                position: "bottom",
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({
                      ...this.state.filter_query,
                      per_page: size,
                      page: current,
                    }),
                  });

                  // this.stateUpdater({
                  //   stateKey: 'filter_query',
                  //   appendObj: {
                  //     per_page: size,
                  //     page: current
                  //   },
                  //   callback: () => {
                  //     this
                  //       .list_table_data
                  //       .config({
                  //         params: {
                  //           ...filter_query,
                  //         }
                  //       })
                  //       .execute();
                  //   }
                  // })
                },
                defaultCurrent: 1,
                current:
                  table_meta.pagination &&
                  parseInt(table_meta.pagination.split("/")[0]),
                pageSize: table_meta && table_meta.requested_count,
                total: table_meta && table_meta.total_count,
                showTotal: (total, range) =>
                  `${formatMoney(range[0], 0)}-${formatMoney(
                    range[1],
                    0
                  )} of ${formatMoney(total, 0)} items`,
              }}
              scroll={{ x: true }}
              size="small"
              className="main-table"
              loading={list_table_data_resp.fetching}
              rowKey={(record) => record.id}
              dataSource={table_data_list}
              columns={table_cols_list}
            />
          </div>
          {/* <input
            name="file"
            type="file"
            onChange={(e) => console.log(e.target.files, "e")}
          /> */}
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    // this.get_detail.execute()
    // this.list_table_data.execute();
    // overrideHeaderTitle(`Table | Data`);
    // overrideHeaderBack('back')
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState(
      {
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query,
        },
      },
      () => {
        this.state.table_switch === 'data' && this.get_detail.execute();
        // this.list_packets.config({
        //     params: {
        //     ...this.state.filter_query
        //     }
        // }).execute()
      }
    );
  }
  componentWillUnmount() {
    // overrideHeaderBack(null)
  }

  componentWillReceiveProps(nextProps) {
    var oldtable_id = this.props.match.params.table_id;
    var newtable_id = nextProps.match.params.table_id;

    if (
      oldtable_id !== newtable_id ||
      (this.props.location &&
        this.props.location.search !== nextProps.location.search)
    ) {
      this.table_id = newtable_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState(
        {
          filter_query: {
            per_page: 100,
            page: 1,
            ...parsed,
          },
        },
        () => {
          if (oldtable_id !== newtable_id) {
            this.setState(
              {
                loading: true,
                table_data_list: [],

                //  For dynamic columns
                table_cols_list: [],

                //  For dynamic form
                data_field: [],
                // For table patch/add data form values
                data_value: {},
                filter_schema: [],
                form_visibility: false,
                form_visibility_file_upload: false,

                //  For allowed methods per table
                allowed_methods: [],

                // For table name
                current_table_name: "",
              },
              () => {
                this.get_detail.forId(this.table_id).execute();
              }
            );
          } else {
            this.list_table_data
              .forId(this.table_id)
              .config({
                params: {
                  ...this.state.filter_query,
                },
              })
              .execute();
          }
        }
      );
    }
  }

}

export default withDomains(TableDataList, "usertable");
